export default "__VITE_ASSET__CliMYfo8__"